/**
 * MarketingActivitiesColumn 常量定义
 */

// 活动类型选项
export const ACTIVITY_OPTIONS = [
    { value: 'vine', label: 'Vine Program' },
    { value: 'influencer', label: 'Influencer 视频' },
    { value: 'product_seeding', label: '红人种草' },
];

// 站点选项
export const MARKETPLACE_OPTIONS = [
    { value: 'US', label: 'US' },
    { value: 'UK', label: 'UK' },
    { value: 'DE', label: 'DE' },
    { value: 'FR', label: 'FR' },
    { value: 'IT', label: 'IT' },
    { value: 'ES', label: 'ES' },
    { value: 'JP', label: 'JP' },
    { value: 'CA', label: 'CA' },
];
